// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1CLho","content":"LoadingAlert_content__1xX94"};